/* ═══════════════════════════════════════════════════════
   MACRA MOON — Global JavaScript
   ═══════════════════════════════════════════════════════ */

/* ─── Pixel Snow on hero (lazy-loaded) ─── */
document.addEventListener('DOMContentLoaded', function() {
    var hero = document.getElementById('hero-section');
    if (hero) {
        var script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/three.js/r128/three.min.js';
        script.onload = function() {
            var snowScript = document.querySelector('script[src*="pixel-snow.js"]');
            if (!snowScript) {
                snowScript = document.createElement('script');
                snowScript.src = document.querySelector('[data-pixel-snow-src]')
                    ? document.querySelector('[data-pixel-snow-src]').dataset.pixelSnowSrc
                    : (window.pixelSnowAssetUrl || '');
                if (snowScript.src) {
                    document.head.appendChild(snowScript);
                }
            }
            /* Wait for pixel-snow.js to define initPixelSnow */
            var checkReady = setInterval(function() {
                if (window.initPixelSnow) {
                    clearInterval(checkReady);
                    window.initPixelSnow(hero, {
                        color: '#ffffff',
                        speed: 0.8,
                        density: 0.2,
                        brightness: 1,
                        pixelResolution: 9999,
                        direction: 140,
                        variant: 'round',
                        depthFade: 10,
                        farPlane: 18,
                    });
                }
            }, 50);
            /* Safety: stop checking after 5s */
            setTimeout(function() { clearInterval(checkReady); }, 5000);
        };
        document.head.appendChild(script);
    }
});

/* ─── Progress bar ─── */
window.addEventListener('scroll', function() {
    var scrollTop = document.documentElement.scrollTop;
    var scrollHeight = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var bar = document.getElementById('progress-bar');
    if (bar) {
        bar.style.width = (scrollTop / scrollHeight * 100) + '%';
    }
});

/* ─── Star generator ─── */
window.generateStars = function(containerOrId, count) {
    var container = typeof containerOrId === 'string'
        ? document.getElementById(containerOrId)
        : containerOrId;
    if (!container || container.dataset.starsInit) return;
    container.dataset.starsInit = '1';
    for (var i = 0; i < count; i++) {
        var star = document.createElement('div');
        star.className = 'star';
        var size = Math.random() * 2.5 + 1;
        star.style.cssText =
            'width: ' + size + 'px; height: ' + size + 'px;' +
            'left: ' + (Math.random() * 100) + '%; top: ' + (Math.random() * 100) + '%;' +
            '--dur: ' + (Math.random() * 4 + 2) + 's;' +
            '--delay: ' + (Math.random() * 5) + 's;';
        container.appendChild(star);
    }
};

/* ─── Auto-init stars from data attributes ─── */
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('[data-stars]').forEach(function(container) {
        var count = parseInt(container.dataset.stars, 10);
        if (count > 0) window.generateStars(container, count);
    });
});

/* ─── Scroll reveal ─── */
document.addEventListener('DOMContentLoaded', function() {
    var revealEls = document.querySelectorAll('.reveal, .reveal-left, .reveal-right, .reveal-scale');
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(e) {
            if (e.isIntersecting) {
                e.target.classList.add('visible');
            }
        });
    }, { threshold: 0.08 });
    revealEls.forEach(function(el) { observer.observe(el); });
});

/* ─── Mobile menu ─── */
document.addEventListener('DOMContentLoaded', function() {
    var burgerBtn = document.getElementById('burger-btn');
    var mobileMenu = document.getElementById('mobile-menu');
    if (burgerBtn && mobileMenu) {
        burgerBtn.addEventListener('click', function() {
            mobileMenu.classList.toggle('hidden');
            var icon = this.querySelector('i');
            icon.classList.toggle('fa-bars');
            icon.classList.toggle('fa-times');
        });
        mobileMenu.querySelectorAll('a').forEach(function(link) {
            link.addEventListener('click', function() {
                mobileMenu.classList.add('hidden');
                var icon = burgerBtn.querySelector('i');
                icon.classList.add('fa-bars');
                icon.classList.remove('fa-times');
            });
        });
    }
});

/* ─── FAQ accordion ─── */
document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.faq-btn').forEach(function(btn) {
        btn.addEventListener('click', function() {
            var item = btn.closest('.faq-item');
            var answer = item.querySelector('.faq-answer');
            var icon = btn.querySelector('.faq-icon');
            var isOpen = answer.style.maxHeight && answer.style.maxHeight !== '0px';

            document.querySelectorAll('.faq-answer').forEach(function(a) { a.style.maxHeight = '0px'; });
            document.querySelectorAll('.faq-icon').forEach(function(i) {
                i.style.transform = 'rotate(0deg)';
                i.textContent = '+';
            });

            if (!isOpen) {
                answer.style.maxHeight = answer.scrollHeight + 'px';
                icon.style.transform = 'rotate(45deg)';
                icon.textContent = '+';
            }
        });
    });
});

/* ─── Contact form ─── */
document.addEventListener('DOMContentLoaded', function() {
    var textarea = document.getElementById('message');
    var counter = document.getElementById('char-count');
    if (textarea && counter) {
        textarea.addEventListener('input', function() {
            var len = textarea.value.length;
            counter.textContent = len + ' / 500';
            if (len > 450) counter.style.color = '#9d825e';
            else counter.style.color = '#b8a07d';
            if (textarea.value.length > 500) textarea.value = textarea.value.substring(0, 500);
        });
    }

    var contactForm = document.getElementById('contact-form');
    if (contactForm) {
        contactForm.addEventListener('submit', function(e) {
            e.preventDefault();
            var btn = document.getElementById('submit-btn');
            var btnText = document.getElementById('btn-text');
            var successMsg = document.getElementById('success-msg');

            btnText.textContent = 'Envoi en cours\u2026';
            btn.disabled = true;
            btn.style.opacity = '0.7';

            setTimeout(function() {
                btn.style.display = 'none';
                successMsg.classList.remove('hidden');
                successMsg.classList.add('flex');
                contactForm.reset();
                if (counter) counter.textContent = '0 / 500';
            }, 1200);
        });
    }

    document.querySelectorAll('.form-input, .form-textarea').forEach(function(input) {
        input.addEventListener('focus', function() {
            var label = input.closest('.form-group');
            label = label ? label.querySelector('.form-label') : null;
            if (label) label.style.color = '#9d825e';
        });
        input.addEventListener('blur', function() {
            var label = input.closest('.form-group');
            label = label ? label.querySelector('.form-label') : null;
            if (label) label.style.color = '';
        });
    });
});
